export const PAGE_PATH = '/konsultatsiya/:id';
export const PAGE_PATH_DYNAMIC = (id: string | number) =>
  `/konsultatsiya/${id}`;
